import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  static targets = [
    "orderId",
    "playerId",
    "productId",
    "teamId",
    "customizationType",
    "draftRevisions",
    "revisionList",
    "draftRevisionsContainer",
  ];

  get currentCustomizationType() {
    return this.customizationTypeTargets?.find((t) => t.checked)?.value;
  }

  get currentDraftRevisions() {
    return this.draftRevisionsTargets?.find((t) => t.checked)?.value;
  }

  connect() {
    this.params = JSON.parse(this.data.get("params"));

    this.loadRevisions(this.currentCustomizationType, 1);
  }

  paginationClick(event) {
    event.preventDefault();
    const page = event.target.dataset.page;
    this.loadRevisions(this.currentCustomizationType, page);
  }
  toggleDraftRevisionsContainer(customizationType) {
    if (this.hasDraftRevisionsContainerTarget) {
      const { draftRevisionCustomizationTypes } = this.params;
      const showDraftRevisions =
        draftRevisionCustomizationTypes.includes(customizationType);

      if (this.currentDraftRevisions == 'true' && !showDraftRevisions) {
        this.draftRevisionsTargets?.find((t) => t.value == 'false').click();
      }

      this.draftRevisionsContainerTarget.style.display = showDraftRevisions
        ? ""
        : "none";
    }
  }

  customizationTypeChange({ currentTarget: { value } }) {
    //this.toggleDraftRevisionsContainer(value);
 //   this.loadRevisions(this.currentCustomizationType, 1);
  }



  async loadRevisions(customizationType, page) {
    const currentPath = window.location.pathname;
    const currentQuery = window.location.search;
    const url = currentPath + currentQuery;

    const link = $("<a>")
      .css("display", "none")
      .attr("href", url + "&customization_type=" + customizationType)
      .attr("data-turbo-frame", "revision_section")
      .appendTo(document.body);

    link.get(0).click();

    link.remove();

  }

  draftRevisionsChange({ currentTarget: { value } }) {
    const currentPath = window.location.pathname;
    const currentQuery = window.location.search;
    const url = currentPath + currentQuery;

    const link = $("<a>")
      .css("display", "none")
      .attr("href", url + "&draft_revisions=" + value)
      .attr("data-turbo-frame", "revision_tag")
      .appendTo(document.body);

    link.get(0).click();

    link.remove();
  }
}
